/* eslint-disable import/no-unresolved */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-plusplus */
/* eslint-disable no-debugger */
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Form, FormikProvider, useFormik } from 'formik';
import { Icon } from '@iconify/react';
import { LoadingButton } from '@material-ui/lab';
import trash2Fill from '@iconify/icons-eva/download-outline';
import editFill from '@iconify/icons-eva/edit-fill';
import zipFill from '@iconify/icons-ant-design/file-zip-fill';
import {
  Box,
  Card,
  Grid,
  Stack,
  TextField,
  Typography,
  Autocomplete,
  InputAdornment,
  IconButton,
  Button
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack5';
import { getCampaignRuleData, getParticularCampaignRule } from 'src/redux/slices/campaignrules';
import { resetSegmentationCount } from 'src/redux/slices/collection';
import { useNavigate } from 'react-router';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import RuleList from './RuleList';

export function SegmentBox({ id }) {
  const dispatch = useDispatch();

  const { campaignRulesSetData, particularCampaignRuleData } = useSelector((state) => state.campaignrules);
  const { countVal, segmentationFile } = useSelector((state) => state.collection);
  const [segmentName, setSegmentName] = useState(`Segment ${id}`);
  const [campaignRuleId, setCampaignRuleId] = useState('');

  const handleSelectCampaignRule = (id) => {
    setCampaignRuleId(id);
    dispatch(resetSegmentationCount());
    if (!particularCampaignRuleData[id]) {
      if (id) {
        dispatch(getParticularCampaignRule(id));
      }
    }
  };

  const downloadMasterFile = (fileName) => {
    const outputFilename = 'MasterFile';
    const link = document.createElement('a');
    link.href = fileName;
    link.setAttribute('download', outputFilename);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <>
      <Card sx={{ width: '100%', p: 3 }}>
        <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
          <Stack direction={{ xs: 'row', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} justifyContent="space-between">
            <TextField
              sx={{ width: '20%' }}
              size="small"
              placeholder="Enter Value"
              value={segmentName}
              error={Boolean(segmentName === '')}
              helperText={segmentName === '' && '*Required'}
              onChange={(e) => setSegmentName(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end" sx={{ position: 'absolute', right: '15px' }}>
                    <Icon icon={editFill} />
                  </InputAdornment>
                ),
                style: {
                  paddingRight: '0px',
                  position: 'relative'
                }
              }}
            />
            <Autocomplete
              size="small"
              sx={{ width: '30%' }}
              options={campaignRulesSetData}
              getOptionLabel={(option) => option.campaign_rule_name}
              onChange={(e, value) => {
                handleSelectCampaignRule(value?.id);
              }}
              renderInput={(params) => <TextField {...params} label="Select Campaign Rule" margin="none" />}
            />
          </Stack>
          {/* component to display inner Rules  */}
          <RuleList selectedCampaignRuleId={parseInt(campaignRuleId, 10)} segmentName={segmentName} id={id} />
          {/* {particularCampaignRuleData[campaignRuleId] && ( */}
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 3, sm: 2 }}
            justifyContent="flex-end"
            alignItems="center"
            sx={{ marginBottom: '15px' }}
          >
            {segmentationFile[segmentName] ? (
              <IconButton
                title="Download Filtered File"
                onClick={() => {
                  if (segmentationFile[segmentName]) downloadMasterFile(segmentationFile[segmentName].file);
                }}
              >
                <Icon icon={trash2Fill} />
              </IconButton>
            ) : (
              ''
            )}
            {countVal[segmentName] ? (
              // <Label variant="outlined" color="primary">
              // </Label>
              <span> No. of Rows : {countVal[segmentName] ? countVal[segmentName].count : ''}</span>
            ) : (
              ''
            )}
          </Stack>
          {/* // )} */}
        </Stack>
      </Card>
    </>
  );
}

SegmentationPage.propTypes = {
  isEdit: PropTypes.bool,
  currentUser: PropTypes.object
};

export default function SegmentationPage() {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [fields, setFields] = useState('');
  const { appliedRuleFile, campaignFile } = useSelector((state) => state.collection);
  const NewUserSchema = Yup.object().shape({
    noOfSegment: Yup.number().required('*Please enter No. of Segments')
  });

  useEffect(() => {
    dispatch(getCampaignRuleData());
  }, [dispatch]);

  useEffect(() => {
    if (!appliedRuleFile) {
      navigate('/dashboard/collection-data/collection');
    }
  }, [appliedRuleFile]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      noOfSegment: ''
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, setErrors }) => {
      try {
        setFields(parseInt(values.noOfSegment, 10));
        setSubmitting(false);
      } catch (error) {
        console.error(error);
        setSubmitting(false);
        setErrors(error);
      }
    }
  });

  const handleDownloadZip = () => {
    if (campaignFile.length !== 0) {
      const zip = new JSZip();
      const files = campaignFile;
      files?.forEach((e) => {
        zip.file(`${e.name}.xlsx`, e.file);
      });
      // for (let file = 0; file < files.length; file++) {
      //   zip.file(files[file].name, files[file]);
      // }
      // zip.file(files.name, files);
      zip.generateAsync({ type: 'blob' }).then((content) => saveAs(content, 'campaign-files'));
    } else {
      enqueueSnackbar('Campaign Rule is not applied on all segment', {
        variant: 'error'
      });
    }
  };

  const { errors, touched, handleSubmit, getFieldProps } = formik;

  return (
    <FormikProvider value={formik}>
      <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <Card sx={{ p: 3 }}>
              <Stack spacing={3}>
                <Stack direction={{ xs: 'column', sm: 'column' }} spacing={{ xs: 3, sm: 2 }}>
                  <Typography variant="h5">
                    Total No. of Entries : {appliedRuleFile ? appliedRuleFile.total_no_entries : ''}{' '}
                  </Typography>
                </Stack>
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={{ xs: 3, sm: 2 }}
                  sx={{ width: '70%', alignItems: 'center' }}
                >
                  <TextField
                    sx={{ width: '40%' }}
                    label="Enter No. of Segments"
                    name="noOfSegment"
                    {...getFieldProps('noOfSegment')}
                    error={Boolean(touched.noOfSegment && errors.noOfSegment)}
                    helperText={touched.noOfSegment && errors.noOfSegment}
                  />
                  <Box>
                    <LoadingButton variant="contained" type="submitt">
                      OK
                    </LoadingButton>
                  </Box>
                </Stack>
                {[...Array(fields)].map((fieldvalue, index) =>
                  fieldvalue === '' ? (
                    <p key={index}> </p>
                  ) : (
                    <Stack
                      key={index}
                      direction={{ xs: 'column', sm: 'row' }}
                      spacing={{ xs: 3, sm: 2 }}
                      justifyContent="space-between"
                      alignItems="center"
                      sx={{ my: 3 }}
                    >
                      <SegmentBox id={index + 1} />
                    </Stack>
                  )
                )}
                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={{ xs: 3, sm: 2 }}
                  justifyContent="flex-end"
                  alignItems="center"
                  // sx={{ marginBottom: '15px' }}
                >
                  <Button
                    variant="contained"
                    type="button"
                    endIcon={<Icon icon={zipFill} />}
                    onClick={() => handleDownloadZip()}
                  >
                    Download
                  </Button>
                </Stack>
              </Stack>
            </Card>
          </Grid>
        </Grid>
      </Form>
    </FormikProvider>
  );
}
